import Image from '@/components/common/image/Image';
import Biography from './Biography';
import type { ArbitraryTypedObject } from '@portabletext/types';

type ProfileProps = {
  name: string;
  position?: string;
  imgAlt: string;
  imgSrc: string;
  biography: ArbitraryTypedObject;
  socialMediaLinks?: (string | null | undefined)[];
};

const Profile = ({
  name,
  position,
  imgAlt,
  imgSrc,
  biography,
  socialMediaLinks,
}: ProfileProps) => {
  const firstName = name.split(' ')[0];

  return (
    <div>
      <h2 className='mt-4 text-xl font-bold leading-5 md:text-5xl'>{name}</h2>
      {position && <h3 className='mt-4 italic'>{position}</h3>}
      <div className='mt-2 md:mt-4 overflow-hidden'>
        <div className='md:float-right md:ml-4 md:my-5 lg:ml-10'>
          <div className='relative h-[208px] md:h-[250px] md:w-[250px] lg:h-[390px] lg:w-[390px]'>
            <Image
              src={imgSrc}
              alt={imgAlt}
              priority
              fill
              sizes='(min-width: 1440px) 33vw, (min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw'
              className='object-contain'
            />
          </div>
        </div>
        <Biography
          biography={biography}
          firstName={firstName}
          socialMediaLinks={socialMediaLinks}
        />
      </div>
    </div>
  );
};

export default Profile;
